import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="legal">
      <h2>Politika privatnosti</h2>
      <h6>Posljednja izmjena: Siječanj 2025.</h6>

      <div className="legal-list">
        <div className="legal-text">
          <h3>
            <div className="legal-number">1.</div> Uvod
          </h3>
          <p>
            Ova Politika privatnosti objašnjava kako prikupljamo, koristimo,
            pohranjujemo i štitimo vaše osobne podatke kada koristite našu web
            stranicu i usluge. Vaša privatnost nam je vrlo važna i posvećeni smo
            zaštiti vaših osobnih podataka u skladu sa zakonodavstvom o zaštiti
            podataka, uključujući Opću uredbu o zaštiti podataka (GDPR).
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">2.</div> Podaci koje prikupljamo
          </h3>
          <p>Možemo prikupljati sljedeće vrste podataka:</p>
          <ul>
            <li>
              <strong>Osobni podaci</strong>: ime, e-mail adresa, broj telefona,
              adresa.
            </li>
            <li>
              <strong>Tehnički podaci</strong>: IP adresa, vrsta preglednika,
              informacije o sesijama i kolačići.
            </li>
            <li>
              <strong>Podaci o aktivnosti</strong>: podaci o tome kako koristite
              naše usluge, stranice koje ste posjetili, vrijeme provedeno na
              stranici.
            </li>
          </ul>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">3.</div> Kako koristimo vaše podatke
          </h3>
          <p>Vaše osobne podatke koristimo u sljedeće svrhe:</p>
          <ul>
            <li>Za pružanje naših usluga i funkcionalnosti na web stranici.</li>
            <li>Za personalizaciju korisničkog iskustva.</li>
            <li>
              Za slanje informacija o našim proizvodima, uslugama ili
              promocijama (ako ste se prijavili za to).
            </li>
            <li>
              Za analizu i poboljšanje naših usluga i korisničkog iskustva.
            </li>
          </ul>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">4.</div> Koliko dugo čuvamo vaše
            podatke?
          </h3>
          <p>
            Vaše podatke čuvamo samo onoliko koliko je potrebno za ostvarenje
            svrhe za koju su prikupljeni. Nakon što podaci više nisu potrebni,
            bit će obrisani ili anonimizirani.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">5.</div> Vaša prava
          </h3>
          <p>
            Kao korisnik, imate određena prava u vezi s vašim osobnim podacima:
          </p>
          <ul>
            <li>
              <strong>Pravo na pristup</strong>: Imate pravo zatražiti
              informacije o tome koje podatke čuvamo o vama.
            </li>
            <li>
              <strong>Pravo na ispravak</strong>: Ako su vaši podaci netačni,
              imate pravo ispraviti ih.
            </li>
            <li>
              <strong>Pravo na brisanje</strong>: Možete zahtijevati da obrišemo
              vaše podatke u određenim okolnostima.
            </li>
            <li>
              <strong>Pravo na prijenosnost podataka</strong>: Imate pravo
              zatražiti kopiju svojih podataka u strukturiranom formatu, kako
              biste ih prenijeli na drugog pružatelja usluga.
            </li>
            <li>
              <strong>Pravo na prigovor</strong>: Imate pravo usprotiviti se
              obradi svojih podataka u određenim okolnostima, kao što je izravni
              marketing.
            </li>
            <li>
              <strong>Pravo na ograničenje obrade</strong>: Možete zahtijevati
              ograničenje obrade vaših podataka u određenim situacijama.
            </li>
          </ul>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">6.</div> Sigurnost podataka
          </h3>
          <p>
            Poduzimamo odgovarajuće tehničke i organizacijske mjere kako bismo
            osigurali sigurnost vaših osobnih podataka i spriječili neovlašteni
            pristup, otkrivanje, izmjenu ili uništenje podataka.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">7.</div> Kolačići
          </h3>
          <p>
            Naša web stranica koristi kolačiće kako bi poboljšala vašu
            korisničku iskustvo. Kolačići su male tekstualne datoteke koje se
            pohranjuju na vašem uređaju kada posjetite našu stranicu. Možete
            kontrolirati korištenje kolačića putem postavki vašeg preglednika.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">8.</div> Dijeljenje podataka s trećim
            stranama
          </h3>
          <p>
            Vaše osobne podatke ne dijelimo s trećim stranama, osim u
            slučajevima kada je to nužno za pružanje naših usluga, kao što je
            angažiranje pružatelja usluga obrade podataka ili kada to zahtijeva
            zakon.
          </p>
        </div>

        <div className="legal-text">
          <h3>
            <div className="legal-number">9.</div> Kontaktirajte nas
          </h3>
          <p>
            Ako imate bilo kakvih pitanja u vezi s našom Politikom privatnosti
            ili obradom vaših osobnih podataka, slobodno nas kontaktirajte putem
            e-maila na: <a href="/">contact@yourwebsite.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
